import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { GetLocationsDataPayload } from "../../payload/GetLocationsData/GetLocationsDataPayload";

const getLocationsDataFetch = (state: LocationsState, action: PayloadAction<GetLocationsDataPayload>) => {
    state.isLoading = true;
}

export default getLocationsDataFetch;